// extracted by mini-css-extract-plugin
export default {"content":"DocumentViewButton_content__q9LiG"};